import React, { useState, useEffect, useRef, useCallback } from 'react';
import Calendar from 'react-calendar';
import CalendarComponent from './CalendarComponent';
import moment from 'moment';
import './style.css';
import { deepCopy, isMobileDevice, dateFormat, dateDiff, monthDiff, in_array, calculateCompStayRange, calculateCompStayRangePromise, calculatePrimaryStayRange, toSdly, getSdyearsAndSdlyOn } from "../../app/util";
import { Button, Popover, ButtonGroup, TextField, Grid } from "@mui/material/";
import { useSelector, useDispatch } from "react-redux";
import { UPDATE_STATE } from '../../actions/types';
import { APP_CACHE, ABORT_REQUEST_CONTROLLERS } from "../../app/config";

export default function SmartDatePicker(props) {
    // const dateRanges = useDateRanges();
    const locale = props.locale || 'en-US'; // Default to English if no locale is provided
    const days_limit = 89; // Maximum date range limit
    const { current_state } = useSelector((state) => state.app);
    const { profile } = useSelector((state) => state.auth);
    const { app_state, ui_state } = current_state;
    const { active_tiles } = ui_state;

    const [datePickerConfig, setDatePickerConfig] = useState(props.datePickerConfig)
    const { primary_stay_range, workspace_controls } = app_state;
    const { isRestrictionsRoomType } = workspace_controls;
    let { navigation, initialRangeType } = datePickerConfig;
    const dispatch = useDispatch();

    const [tempDateRange, setTempDateRange] = useState(primary_stay_range)
    const [displayDateRange, setDisplayDateRange] = useState(props.dateRange)

    const [rangeType, setRangeType] = useState(initialRangeType);
    const [rangeSegment, setRangeSegment] = useState("current_month");

    const [calendarOn, setCalendarOn] = useState("range");
    const [calendarMonthFrom, setCalendarMonthFrom] = useState(null);
    const [calendarMonthTo, setCalendarMonthTo] = useState(null);
    const [isApplyEnable, setIsApplyEnable] = useState(true)

    const [anchorEl, setAnchorEl] = React.useState(null);
    const dateDisplayFormat ="MMM DD, YYYY";
    const [singleDate, setSingleDate] = useState(moment(tempDateRange.date_from).format(dateDisplayFormat));
    const [asOfDate, setAsOfDate] = useState(moment(tempDateRange.as_of_date).format(dateDisplayFormat));
    const [inputDateFrom, setInputDateFrom] = useState(moment(tempDateRange.date_from).format(dateDisplayFormat));
    const [inputDateUntil, setInputDateUntil] = useState(moment(tempDateRange.date_until).format(dateDisplayFormat));

    const openDatePicker = Boolean(anchorEl);
    const id = openDatePicker ? 'date-picker-popover' : undefined;

    let selector = (<span></span>);
    const initialRender = useRef(true);

    const isValidDateAndFormat = (dateString) =>{
        return  moment(dateString, dateDisplayFormat, true).isValid();
    };

    useEffect(() => {
        // const { date_from, date_until } = dateRanges.primary_stay_range;


        if (app_state.date_range_type && app_state.date_range_type.split('_')[0] !== 'propertyChanged') {
            // debugger;
            const { date_from, date_until } = app_state.primary_stay_range;

            if (app_state.date_range_type === 'scopeTypeChanged_Dba') {
                let { date_from } = app_state.primary_stay_range;
                let from_value = moment(date_from);
                setRangeType('single_date');
                onDateChange(null, [from_value], 'single');
                applyChange('singleStaydates');
            }
            if (app_state.date_range_type === 'scopeTypeChanged_Date') {
                let { date_from, date_until } = app_state.primary_stay_range;
                let primary_stay_range = calculatePrimaryStayRange({ date_from, date_range: app_state.historicalRange });
                let from_value = moment(primary_stay_range.date_from);
                let until_value = moment(primary_stay_range.date_until);
                // When the isRestrictionsRoomType type is product and tile is restrictions, we need to check if the date range is valid and cap is not exceeded
                if (isRestrictionsRoomType === 'product' && active_tiles.includes('restrictions')) {
                    let diff = moment(until_value).diff(from_value, 'days');
                    let as_of_date = profile.current_property_date;
                    onDateChange(null, as_of_date, 'as_of');

                    if (diff > days_limit) {
                        until_value = moment(date_from).add(days_limit, 'days');
                        app_state.historicalRange.date_until = until_value;
                    }
                }

                onDateChange(null, [from_value], 'date_from');
                onDateChange(null, [until_value], 'date_until');
                setRangeType('range');
                applyChange('staydates');
            }

            if (app_state.date_range_type === 'logsSingleDate') {
                let { date_from } = app_state.primary_stay_range;
                let from_value = moment(date_from);
                setRangeType('single_date');
                onDateChange(null, [from_value], 'single');

                applyChange('staydates');
            }

            if (app_state.date_range_type === 'logsDateRange') {
                let { date_from, date_until } = app_state.historicalRange;
                let from_value = moment(date_from);
                let until_value = moment(date_until);
                onDateChange(null, [from_value], 'date_from');
                onDateChange(null, [until_value], 'date_until');
                setRangeType('range');
                applyChange('staydates');
            }

            if (app_state.date_range_type === 'asOfChanged') {
                let as_of_date = deepCopy(app_state.primary_stay_range.as_of_date);
                setTempDateRange({ ...tempDateRange, as_of_date });
                setDisplayDateRange({ ...displayDateRange, as_of_date });
                setRangeType('range');
            }


            if (app_state.date_range_type.split('_')[0] === "rangeTileChange") {
                let changeType = app_state.date_range_type.indexOf('_sdYear') !== -1 ? 'sdYearChanged' : '';
                let tile = app_state.date_range_type.split('_')[1];
                let from_value = moment(date_from);
                let until_value = moment(date_until);
                 // When the isRestrictionsRoomType type is product and tile is restrictions, we need to check if the date range is valid and cap is not exceeded
                if (isRestrictionsRoomType === 'product' && active_tiles.includes('restrictions')) {
                    let diff = moment(until_value).diff(from_value, 'days');
                    let as_of_date = profile.current_property_date;
                    onDateChange(null, as_of_date, 'as_of');
                    applyChange('staydates');

                    if (diff > days_limit) {
                        until_value = moment(date_from).add(days_limit, 'days');
                        app_state.historicalRange.date_until = until_value;
                        setRangeType('range');
                        applyChange('staydates');
                    }
                }
                onDateChange(null, [from_value], 'date_from');
                onDateChange(null, [until_value], 'date_until');

                if (app_state.workspace_controls.scopeType === 'Dba') {
                    setRangeType('single_date');
                    applyChange('singleStaydates');
                }

                if (app_state.workspace_controls.scopeType === 'Date') {
                    setRangeType('range');
                    applyChange('staydates_' + 'rangeTileChange', null, changeType);
                }
            }

            if (app_state.workspace_controls.scopeType === 'Dba_x') {
                if (app_state.date_range_type === 'single_date') {
                    let from_value = moment(date_from);
                    setRangeType('single_date');
                    onDateChange(null, [from_value], 'single');

                    applyChange('singleStaydates');
                }
                if (app_state.date_range_type === 'singlePace') {
                    let from_value = moment(date_from);
                    setRangeType('single_date');
                    onDateChange(null, [from_value], 'single');
                    applyChange('staydates');
                }
                if (app_state.workspace_controls.scopeType === "Dba") {
                    let { date_from } = app_state.primary_stay_range;
                    tempDateRange.date_until = displayDateRange.date_from;
                    let from_value = moment(date_from);
                    setRangeType('single_date');
                    onDateChange(null, [from_value], 'single');
                    applyChange('staydates');
                }

            }

            if (app_state.date_range_type === 'range') {
                let from_value = moment(date_from);
                let until_value = moment(date_until);
                onDateChange(null, [from_value], 'date_from');
                onDateChange(null, [until_value], 'date_until');
                setRangeType('range');
                applyChange('staydates');
            }

            if (app_state.date_range_type === 'pricingRoomType' ||
                'restrictionsRoomType' === app_state.date_range_type
            ) {
                rangeSegmentChange(29);
                setRangeType('range');
                applyChange('staydates');
            }

        }

        if (app_state.date_range_type && app_state.date_range_type.split('_')[0] === 'propertyChanged') {
            /** LRV-1035 make stay date retain  */
            let as_of_date = app_state.primary_stay_range.as_of_date;//new moment(profile.current_property_date).startOf('day').format('YYYY-MM-DD');
            let date_from = app_state.primary_stay_range.date_from;// new moment(profile.current_property_date).startOf('month').format('YYYY-MM-DD');
            let date_until = app_state.primary_stay_range.date_until;// new moment(profile.current_property_date).endOf('month').format('YYYY-MM-DD');
            let tempDateRange = { as_of_date, date_from, date_until };

            calculateCompStayRangePromise({ primary_stay_range: tempDateRange, workspace_controls, property_id: app_state.property_id })
                .then((rs) => {
                    ui_state.showspinner = true;
                    app_state.date_range_type = '';
                    app_state.comp_stay_range = rs;
                    app_state.data_load = true;
                    app_state.kpi_load = true;
                    // app_state.workspace_controls.scopeType = "Date";
                    app_state.primary_stay_range = { as_of_date, date_from, date_until };
                    // app_state.rerender_app = app_state.property_id;
                    dispatch({
                        type: "UPDATE_STATE",
                        payload: {
                            app_state,
                            ui_state
                        }
                    });
                });
            // updateAppState('stay_range', , "datepicker_update"));
            let dateRange = deepCopy(tempDateRange);
            setDisplayDateRange(dateRange);
            setTempDateRange(dateRange);
            setSingleDate(moment(dateRange.date_from).format(dateDisplayFormat));
            setAsOfDate(moment(dateRange.as_of_date).format(dateDisplayFormat));
            setInputDateFrom(moment(dateRange.date_from).format(dateDisplayFormat));
            setInputDateUntil(moment(dateRange.date_until).format(dateDisplayFormat));
        }

    }, [
        //app_state.workspace_controls.scopeType,
        app_state.date_range_type,
        //app_state.primary_stay_range.as_of_date,
        // app_state.primary_stay_range.date_from,
        // app_state.primary_stay_range.date_until,
    ]);

    // Datepicker Handle - Product Level Restriction
    // useEffect(() => {
    //     if(in_array(["restrictions"],ui_state.active_tiles) && app_state.workspace_controls.isRestrictionsRoomType === "product"){
    //         let nav = {
    //             single_date: {
    //                 type: "singleDate",
    //                 range_segments: [],
    //                 inputs: [],
    //                 as_of_date: true,
    //                 label: "Date",
    //             },
    //         }
    //         let { date_from } = app_state.primary_stay_range;
    //         let from_value = moment(date_from);
    //         onDateChange(null, [from_value], 'single');
    //         setRangeType('single_date');
    //         applyChange('singleStaydates');

    //         setNavigation(nav)
    //     }
    //     else {
    //         let nav = {
    //             single_date: {
    //                 type: "singleDate",
    //                 range_segments: [],
    //                 inputs: [],
    //                 as_of_date: true,
    //                 label: "Date",
    //             },
    //             range: {
    //                 type: "range",
    //                 range_segments: ["current_month", 29, 59, 89],
    //                 inputs: ["date_from", "date_until"],
    //                 as_of_date: true,
    //                 label: "Range",
    //             },
    //             weeks: {
    //                 type: "weeks",
    //                 range_segments: [],
    //                 inputs: ["date_from", "date_until"],
    //                 as_of_date: true,
    //                 label: "Weeks",
    //             },
    //             months: {
    //                 type: "months",
    //                 range_segments: [],
    //                 inputs: ["date_from", "date_until"],
    //                 as_of_date: true,
    //                 label: "Months",
    //             },
    //         }
    //         let { date_from, date_until } = app_state.primary_stay_range;
    //         let primary_stay_range = calculatePrimaryStayRange({ date_from, date_range: app_state.historicalRange });
    //         let from_value = moment(primary_stay_range.date_from);
    //         let until_value = moment(primary_stay_range.date_until);
    //         onDateChange(null, [from_value], 'date_from');
    //         onDateChange(null, [until_value], 'date_until');
    //         setRangeType('range');
    //         applyChange('staydates');

    //         setNavigation(nav)
    //     }
    // }, [app_state.workspace_controls.isRestrictionsRoomType])
    // END Datepicker Handle - Product Level Restriction

    useEffect(() => {
        if (initialRender.current === false) {
            switch (rangeType) {
                case "single_date":
                    if (
                        isValidDateAndFormat(singleDate) &&
                        isValidDateAndFormat(asOfDate) &&
                        moment(asOfDate, dateDisplayFormat).isSameOrBefore(moment(profile.current_property_date))
                    ) {
                        setIsApplyEnable(true)
                    } else {
                        setIsApplyEnable(false)
                    }
                    break;
                case "range":
                    if (
                        isValidDateAndFormat(asOfDate) &&
                        moment(asOfDate, dateDisplayFormat).isSameOrBefore(moment(profile.current_property_date)) &&
                        isValidDateAndFormat(inputDateFrom) &&
                        isValidDateAndFormat(inputDateUntil) &&
                        moment(new Date(inputDateUntil)).diff(new Date(inputDateFrom), 'days') >= 0
                    ) {
                        setIsApplyEnable(true)
                        let hasError = rangeCapErrorCheck(isRestrictionsRoomType, active_tiles, inputDateFrom, inputDateUntil, days_limit);
                        if (hasError) {
                            setIsApplyEnable(false);
                        }
                    } else {
                        setIsApplyEnable(false)
                    }
                    break;
                case "weeks":
                case "months":
                    if (
                        isValidDateAndFormat(asOfDate) &&
                        moment(asOfDate, dateDisplayFormat).isSameOrBefore(moment(profile.current_property_date))
                    ) {
                        setIsApplyEnable(true)
                    } else {
                        setIsApplyEnable(false)
                    }
                    break;
                default:
                    break;
            }

            let range_segment = determineRangeSegment(tempDateRange);
            console.log("range_segment", range_segment);
            setRangeSegment(range_segment);
        }
        initialRender.current = false
    }, [singleDate, asOfDate, inputDateFrom, inputDateUntil, rangeType])

    const rangeCapErrorCheck = (isRestrictionsRoomType, active_tiles, date_from, date_until, days_limit) => {
        let hasError = false;
        const diff = moment(date_until).diff(date_from, 'days');

        if (isRestrictionsRoomType === 'product' && active_tiles.includes('restrictions')) {
            if (diff > days_limit) {
                hasError = true;
            }
        }
        return hasError;
    }

    const openDatePickerHandler = (event) => {
        setAnchorEl(event.currentTarget)
        setSingleDate(moment(displayDateRange.date_from).format(dateDisplayFormat));
        setAsOfDate(moment(displayDateRange.as_of_date).format(dateDisplayFormat));
        setInputDateFrom(moment(displayDateRange.date_from).format(dateDisplayFormat));
        setInputDateUntil(moment(displayDateRange.date_until).format(dateDisplayFormat));
        setCalendarOn("")
        let range_segment = determineRangeSegment(displayDateRange);
        setRangeSegment(range_segment);
        handleRangeChange(rangeType);
    }

    const closeDatePickerHandler = () => {
        setAsOfDate(moment(displayDateRange.as_of_date).format(dateDisplayFormat));
        tempDateRange.as_of_date = moment(displayDateRange.as_of_date).format("YYYY-MM-DD");
        setAnchorEl(null)
    }

    const applyChange = useCallback((key, initiater, changeType) => {
        // debugger;
        //Reseting chart cache data
        APP_CACHE.chartData = null;

        if ("singleStaydates" === key) {
            let primary_stay_range = app_state.primary_stay_range;
            tempDateRange.date_until = primary_stay_range.date_from;
            displayDateRange.date_until = primary_stay_range.date_from;
        }

        let controls = deepCopy(app_state.workspace_controls);
        calculateCompStayRangePromise({ primary_stay_range: tempDateRange, workspace_controls: app_state.workspace_controls, property_id: app_state.property_id })
            .then((rs) => {
                let sdly_asof = rs.as_of_date
                let sdly_from = rs.date_from
                let sdly_to = rs.date_until;
                let { sdtly_asof, sdtly_from, sdtly_to } = rs;
                app_state.metas.osr = { sdly_from: sdly_from, sdly_to: sdly_to, sdly_asof: sdly_asof, sdtly_asof, sdtly_from, sdtly_to };
                //console.log("rrrrrrrrrrrrrrrr", rs, key, initiater)
                let comp_stay_range = deepCopy(rs);
                app_state.comp_stay_range = comp_stay_range;
                let historicalRange = { ...app_state.primary_stay_range, ...app_state.historicalRange };
                // APP_CACHE.controls = app_state.workspace_controls;
                APP_CACHE.stay_range = [tempDateRange.date_from, tempDateRange.date_until, tempDateRange.as_of_date];
                APP_CACHE.primary_stay_range = deepCopy(tempDateRange);
                APP_CACHE.comp_stay_range = deepCopy(comp_stay_range);
                APP_CACHE.metas = app_state.metas;
                // setDisplayDateRange({ ...displayDateRange, ...tempDateRange });
                // setAnchorEl(null);

                if (initiater && initiater === 'picker') {
                    //historicalRange = deepCopy(tempDateRange);
                    //Abort in progress API calls
                    //Aborting active apis
                    let abotControllers = ABORT_REQUEST_CONTROLLERS;
                    abotControllers.forEach((val, key) => {
                        val.abort();
                        // console.log('abotControllers', ABORT_REQUEST_CONTROLLERS.get(key));
                        // if (val && !['OSR', 'OSRContrainedForecast'].includes(key)) {
                        //     val.abort();
                        // }
                    });

                    if (app_state.workspace_controls.scopeType === 'Date') {
                        historicalRange = deepCopy(tempDateRange);
                    }
                    // sendLog({ category: "datepicker", action: "changedates" }, { ...current_state },{
                    //     app_state: {
                    //         historicalRange,
                    //         primary_stay_range: { ...tempDateRange },
                    //         data_load: false, kpi_load: false
                    //     },
                    //     ui_state: {
                    //         showspinner: true,
                    //     }
                    // })
                    window.analyze.track("tile_change", {
                        "selected_tile": ui_state.active_tiles.join(),
                        previous_dates: app_state.primary_stay_range,
                        new_dates: { ...tempDateRange },
                        property_id: app_state.property_id, property_name: app_state.property_name,
                        data_view: app_state.user_view, historicalRange,
                    }, { ...current_state }, {
                        app_state: {
                            historicalRange,
                            primary_stay_range: { ...tempDateRange },
                            data_load: false, kpi_load: false
                        },
                        ui_state: {
                            showspinner: true,
                        }
                    });

                    dispatch({
                        type: UPDATE_STATE, payload: {
                            app_state: {
                                historicalRange,
                                primary_stay_range: { ...tempDateRange },
                                comp_stay_range,
                                data_load: false, kpi_load: false,
                                workspace_controls: controls
                            },
                            ui_state: {
                                showspinner: true,
                                // show_chart_icon: true
                            }
                        }
                    });
                }
                // debugger;
                let curr_app_state = app_state;
                let as_of_date = moment(new Date(asOfDate)).format('YYYY-MM-DD');
                // tempDateRange.as_of_date = as_of_date;

                if (['Date', 'DBA'].includes(app_state.workspace_controls.scopeType)
                    && !app_state.workspace_controls.isRoomTypePricing
                    && ui_state.active_tiles[0] !== 'pricing') {
                    //historicalRange = deepCopy(app_state.primary_stay_range);
                    let tempDateRange_copy = deepCopy(tempDateRange);
                    tempDateRange_copy = { primary_stay_range: tempDateRange_copy, comp_stay_range: app_state.comp_stay_range, workspace_controls, property_id: app_state.property_id }
                    // debugger;
                    // app_state.comp_stay_range = calculateCompStayRange(tempDateRange_copy);
                }

                if ("singleStaydates" === key) {
                    let primary_stay_range = app_state.primary_stay_range;
                    // debugger;
                    tempDateRange.date_until = primary_stay_range.date_from;
                    displayDateRange.date_until = primary_stay_range.date_from;
                    let comp_stay_range = calculateCompStayRange({ primary_stay_range: tempDateRange, workspace_controls: app_state.workspace_controls, property_id: app_state.property_id });

                    primary_stay_range.date_until = primary_stay_range.date_from;

                    //APP_CACHE.primary_stay_range = deepCopy(primary_stay_range);
                    //APP_CACHE.comp_stay_range = deepCopy(comp_stay_range);

                    // app_state.workspace_controls.scopeType = APP_CACHE.controls.scopeType;
                    // debugger;
                    app_state.date_range_type = '';

                    setTimeout(() => {

                        dispatch({
                            type: UPDATE_STATE,
                            payload: {
                                app_state: {
                                    date_range_type: '',
                                    primary_stay_range,
                                    comp_stay_range,
                                    historicalRange,
                                    // workspace_controls: { ...APP_CACHE.controls, scopeType: 'Dba' },
                                    data_load: true, kpi_load: true
                                },
                                ui_state: { showspinner: true }
                            }
                        });
                    }, 100);

                }

                if ("staydates" === key) {
                    if (datePickerConfig.dateRangeKey === "primary_stay_range") {
                        let app_state = {}; let ui_state = {};
                        app_state.primary_stay_range = { ...tempDateRange };
                        app_state.data_load = true;
                        app_state.kpi_load = true;
                        ui_state.showspinner = true;
                        app_state.historicalRange = historicalRange;
                        app_state.as_of_date = as_of_date;                        
                        if(isRestrictionsRoomType === 'product' && active_tiles.includes('restrictions')){
                            app_state.as_of_date = app_state.primary_stay_range.as_of_date;
                        }
                        
                        //added if due to date_range_type reset when open any logs report in date mode and refresh page.
                        if(!(['DailyRatesendStatus', 'rm_room_type_ratesend_status', "restrictions_push_status", 'plr_logs'].includes(active_tiles[0]))){
                            app_state.date_range_type = '';  
                        }
                        app_state.comp_stay_range = comp_stay_range; //calculateCompStayRange({ primary_stay_range: app_state.primary_stay_range, workspace_controls, property_id: app_state.property_id });

                        APP_CACHE.primary_stay_range = app_state.primary_stay_range;
                        APP_CACHE.comp_stay_range = app_state.comp_stay_range;
                        // debugger;
                        setTimeout(() => {

                            dispatch({
                                type: UPDATE_STATE, payload: {
                                    app_state: {
                                        ...app_state,
                                    },
                                    ui_state: { ...ui_state }
                                }
                            })
                        }, 100);
                    }
                }

                if ("staydates_rangeTileChange" === key) {
                    // let final_state = APP_CACHE.final_state ? APP_CACHE.final_state : { app_state: {}, ui_state: {} };
                    // debugger;

                    if (datePickerConfig.dateRangeKey === "primary_stay_range") {
                        let app_state = {}; let ui_state = {};
                        // app_state.primary_stay_range = calculatePrimaryStayRange({ date_from: tempDateRange.date_from, date_range: curr_app_state.historicalRange });
                        app_state.data_load = true;
                        app_state.kpi_load = true;

                        app_state.historicalRange = historicalRange;
                        if(isRestrictionsRoomType !== 'product' && !active_tiles.includes('restrictions')){
                            app_state.as_of_date = as_of_date;
                        }
                        app_state.date_range_type = '';
                        app_state.workspace_controls = controls;
                        ui_state.showspinner = true;
                        setTimeout(() => {
                            // `controls` was copied before SdYears re-validated Compare With for the new tiles (e.g. removing
                            // Market drops a market-only year back to '---'). Take its result from APP_CACHE, otherwise
                            // Workspace sees sdYear/sdlyOn differ from APP_CACHE when data returns and never stops loading.
                            if (APP_CACHE.controls) {
                                controls.sdlyOn = APP_CACHE.controls.sdlyOn;
                                controls.sdYear = APP_CACHE.controls.sdYear;
                                controls.sdYearsArr = APP_CACHE.controls.sdYearsArr;
                            }

                            dispatch({
                                type: UPDATE_STATE,
                                payload: {
                                    app_state,
                                    ui_state
                                }
                            });
                        }, 100);
                    }
                }

                if (key === "as_of_date") {
                    let app_state = {}; let ui_state = {};
                    // let historicalRange = curr_app_state.historicalRange;
                    if (curr_app_state.workspace_controls.scopeType !== "Dba") {
                        //app_state.historicalRange = { ...historicalRange, ...deepCopy(tempDateRange) };
                    }
                    //app_state.primary_stay_range = deepCopy({ ...tempDateRange, as_of_date });
                    app_state.data_load = true;
                    app_state.kpi_load = true;
                    ui_state.showspinner = true;
                    app_state.comp_stay_range = comp_stay_range; //calculateCompStayRange({ primary_stay_range: tempDateRange, workspace_controls, property_id: app_state.property_id });
                    app_state.as_of_date = as_of_date;
                    app_state.date_range_type = '';

                    setTimeout(() => {
                        curr_app_state.workspace_controls.sdlyOn = APP_CACHE.controls.sdlyOn;
                        curr_app_state.workspace_controls.sdYear = APP_CACHE.controls.sdYear;
                        curr_app_state.workspace_controls.sdYearsArr = APP_CACHE.controls.sdYearsArr;
                        
                        dispatch({
                            type: UPDATE_STATE, payload: {
                                app_state: {
                                    ...app_state,
                                    // historicalRange: { ...app_state.historicalRange, ...historicalRange },
                                    as_of_date,
                                    workspace_controls: { ...curr_app_state.workspace_controls },
                                },
                                ui_state: { ...ui_state }
                            }
                        });
                    }, 100);

                }


                // let comp_stay_range = calculateCompStayRange({ primary_stay_range: tempDateRange, workspace_controls: app_state.workspace_controls, property_id: app_state.property_id });
                // debugger;
                // APP_CACHE.primary_stay_range = deepCopy(tempDateRange);
                APP_CACHE.comp_stay_range = deepCopy(comp_stay_range);

                //Reseting the final proccessed data in APP_CACHE
                // debugger;
                APP_CACHE.chartData = null;
                APP_CACHE.tableData = null;
                APP_CACHE.renderTableData = null;

                // APP_CACHE.controls = deepCopy(app_state.workspace_controls);
                // setDisplayDateRange(displayDateRange);
                setDisplayDateRange({ ...displayDateRange, ...tempDateRange });
            });
        setAnchorEl(null);
    });


    const determineRangeSegment = useCallback((tempDateRange, type) => {
        let daysDiff = dateDiff(tempDateRange.date_until, tempDateRange.date_from);
        if (type === "comparisonStayDates" && daysDiff === 364) {
            return "sdly";
        }
        let startOfMonth = moment(new Date()).startOf('month');
        let endOfMonth = moment(tempDateRange.date_until).endOf('month');
        if (dateDiff(startOfMonth, tempDateRange.date_from) === 0 && dateDiff(endOfMonth, tempDateRange.date_until) === 0 && daysDiff <= 31) {
            return "current_month";
        }
        let isToday = (dateDiff(moment(), tempDateRange.date_from) === 0) ? true : false;
        if (isToday) {
            if (daysDiff === 29 || daysDiff === 59 || daysDiff === 89) {
                return daysDiff;
            }
        }
        else {
            return "custom";
        }
        return "current_month"
    });

    const shiftBackward = useCallback(() => {
        const appState = { primary_stay_range: {}, comp_stay_range: {} };
        let isMonth = false;
        let startOfMonth = new moment(displayDateRange.date_from).startOf('month');
        let endOfMonth = new moment(displayDateRange.date_until).endOf('month');
        let dateFrom = new moment(displayDateRange.date_from);
        let dateUntil = new moment(displayDateRange.date_until);
        let diffDays = dateDiff(dateUntil, dateFrom);
        let difMonth = monthDiff(dateUntil, dateFrom);
        if (startOfMonth.format("YYYY-MM-DD") === dateFrom.format("YYYY-MM-DD")
            && endOfMonth.format("YYYY-MM-DD") === dateUntil.format("YYYY-MM-DD")) {
            isMonth = true;
        }
        if (isMonth) {
            tempDateRange.date_from = dateFrom.subtract(difMonth, 'month').startOf('month').format("YYYY-MM-DD");
            tempDateRange.date_until = dateUntil.subtract(difMonth, 'month').endOf('month').format("YYYY-MM-DD");
        }
        if (diffDays === 0) {
            tempDateRange.date_from = dateFrom.subtract(1, 'day').format("YYYY-MM-DD");
            tempDateRange.date_until = dateUntil.subtract(1, 'day').format("YYYY-MM-DD");
        }
        if (!isMonth && diffDays > 0) {
            tempDateRange.date_from = dateFrom.subtract(diffDays + 1, 'day').format("YYYY-MM-DD");
            tempDateRange.date_until = dateUntil.subtract(diffDays + 1, 'day').format("YYYY-MM-DD");
        }
        if (datePickerConfig.dateRangeKey === "primary_stay_range") {
            if (in_array(["hotel_summary", "market_summary"], ui_state.active_tiles)) {
                appState.historicalRange = deepCopy(appState.primary_stay_range);
            }
            appState.primary_stay_range.date_from = tempDateRange.date_from;
            appState.primary_stay_range.date_until = tempDateRange.date_until;
            // appState.comp_stay_range.date_from = toSdly(tempDateRange.date_from);
            // appState.comp_stay_range.date_until = toSdly(tempDateRange.date_until);

            appState.data_load = true;
            appState.kpi_load = true;
            appState.date_range_type = '';

            if (tempDateRange.date_from !== tempDateRange.date_until) {
                if (!in_array(["hotel_summary", "market_summary"], ui_state.active_tiles)) {
                    appState.historicalRange = deepCopy(appState.primary_stay_range);
                }
            }
            let comp_stay_range = calculateCompStayRange({ primary_stay_range: tempDateRange, workspace_controls, property_id: app_state.property_id });
            APP_CACHE.primary_stay_range = deepCopy(tempDateRange);
            APP_CACHE.comp_stay_range = deepCopy(comp_stay_range);

            displayDateRange.date_from = tempDateRange.date_from;
            displayDateRange.date_until = tempDateRange.date_until;
            setDisplayDateRange(displayDateRange);
            setTempDateRange(tempDateRange)

            ui_state.showspinner = true;
            APP_CACHE.compStayRange = {}
            calculateCompStayRangePromise({ primary_stay_range: tempDateRange, workspace_controls: app_state.workspace_controls, property_id: app_state.property_id })
                .then((rs) => {
                    let sdly_asof = rs.as_of_date
                    let sdly_from = rs.date_from
                    let sdly_to = rs.date_until;
                    let { sdtly_asof, sdtly_from, sdtly_to } = rs;
                    app_state.metas.osr = { sdly_from: sdly_from, sdly_to: sdly_to, sdly_asof: sdly_asof, sdtly_asof, sdtly_from, sdtly_to };

                    //Reseting chart cache data
                    APP_CACHE.chartData = null;
                    APP_CACHE.metas = app_state.metas;
                    dispatch({
                        type: UPDATE_STATE, payload: {
                            app_state: {
                                ...appState,
                                date_range_type: '',
                                primary_stay_range: { ...tempDateRange, date_from: tempDateRange.date_from, date_until: tempDateRange.date_until },
                                comp_stay_range: deepCopy(rs),
                                data_load: true, kpi_load: true
                            },
                            ui_state: {
                                showspinner: true
                            }
                        }
                    });

                });
        }
    })

    const shiftFoward = useCallback(() => {
        // debugger;
        let appState = { primary_stay_range: {}, comp_stay_range: {} };
        let isMonth = false;
        let startOfMonth = new moment(displayDateRange.date_from).startOf('month');
        let endOfMonth = new moment(displayDateRange.date_until).endOf('month');
        let dateFrom = new moment(displayDateRange.date_from);
        let dateUntil = new moment(displayDateRange.date_until);
        let diffDays = dateDiff(dateUntil, dateFrom);
        let difMonth = monthDiff(dateUntil, dateFrom);
        if (startOfMonth.format("YYYY-MM-DD") === dateFrom.format("YYYY-MM-DD")
            && endOfMonth.format("YYYY-MM-DD") === dateUntil.format("YYYY-MM-DD")) {
            isMonth = true;
        }

        if (isMonth) {
            tempDateRange.date_from = dateFrom.add(difMonth, 'month').startOf('month').format("YYYY-MM-DD");
            tempDateRange.date_until = dateUntil.add(difMonth, 'month').endOf('month').format("YYYY-MM-DD");
        }
        if (diffDays === 0) {
            tempDateRange.date_from = dateFrom.add(1, 'day').format("YYYY-MM-DD");
            tempDateRange.date_until = dateUntil.add(1, 'day').format("YYYY-MM-DD");
        }
        if (!isMonth && diffDays > 0) {
            tempDateRange.date_from = dateUntil.add(1, 'day').format("YYYY-MM-DD");
            tempDateRange.date_until = dateUntil.add(diffDays, 'day').format("YYYY-MM-DD");
        }

        if (datePickerConfig.dateRangeKey === "primary_stay_range") {
            appState.primary_stay_range.date_from = tempDateRange.date_from;
            appState.primary_stay_range.date_until = tempDateRange.date_until;
            //appState.comp_stay_range.date_from = toSdly(tempDateRange.date_from);
            //appState.comp_stay_range.date_until = toSdly(tempDateRange.date_until);
            if (tempDateRange.date_from !== tempDateRange.date_until) {
                appState.historicalRange = deepCopy(appState.primary_stay_range);
            }

            appState.data_load = true;
            appState.kpi_load = true;
            appState.date_range_type = '';

            if (tempDateRange.date_from !== tempDateRange.date_until) {
                appState.historicalRange = deepCopy(appState.primary_stay_range);
            }

            let comp_stay_range = {}; //calculateCompStayRange({ primary_stay_range: tempDateRange, workspace_controls, property_id: app_state.property_id });
            APP_CACHE.primary_stay_range = deepCopy(tempDateRange);
            APP_CACHE.comp_stay_range = deepCopy(comp_stay_range);

            displayDateRange.date_from = tempDateRange.date_from;
            displayDateRange.date_until = tempDateRange.date_until;
            setDisplayDateRange(displayDateRange);
            setTempDateRange(tempDateRange);

            ui_state.showspinner = true;
            APP_CACHE.compStayRange = {}
            calculateCompStayRangePromise({ primary_stay_range: tempDateRange, workspace_controls: app_state.workspace_controls, property_id: app_state.property_id })
                .then((rs) => {

                    let sdly_asof = rs.as_of_date
                    let sdly_from = rs.date_from
                    let sdly_to = rs.date_until;
                    let { sdtly_asof, sdtly_from, sdtly_to } = rs;
                    app_state.metas.osr = { sdly_from: sdly_from, sdly_to: sdly_to, sdly_asof: sdly_asof, sdtly_asof, sdtly_from, sdtly_to };

                    comp_stay_range = rs;
                    APP_CACHE.comp_stay_range = deepCopy(comp_stay_range);
                    //Reseting chart cache data
                    APP_CACHE.chartData = null;
                    APP_CACHE.metas = app_state.metas;
                    dispatch({
                        type: UPDATE_STATE, payload: {
                            app_state: {
                                ...appState,
                                primary_stay_range: tempDateRange,
                                comp_stay_range: deepCopy(comp_stay_range),
                                // historicalRange: deepCopy(app_state.primary_stay_range),
                                // data_load: true,
                                // kpi_load: true,
                                // ...app_state,
                            },
                            ui_state: {
                                showspinner: true
                                // ...ui_state,
                            }
                        }
                    });


                });
        }
    });

    const handleDateInputFocus = (calendar_on, value) => {
        //alert(value)
        if (calendar_on === "date_from" && isValidDateAndFormat(value)) {
            setCalendarMonthFrom(moment(value, dateDisplayFormat).toDate());
        }
        if (calendar_on === "date_until" && isValidDateAndFormat(value)) {
            setCalendarMonthTo(moment(value, dateDisplayFormat).toDate());
        }
        setCalendarOn(calendar_on)
    }
    const handleDateInputChange = useCallback((date, key) => {
        if (key === "single") {
            setSingleDate(date)
        }
        if (key === "as_of") {
            setAsOfDate(date)
        }
        if (key === "date_from") {
            setInputDateFrom(date)
        }
        if (key === "date_until") {
            setInputDateUntil(date)
        }

        // Parse the date with the expected display format
        const parsedDate = moment(date, dateDisplayFormat, true);
        
        // Check if the date is valid in the expected format
        if (parsedDate.isValid()) {
            if (key === "single") {
                tempDateRange.date_from = parsedDate.format("YYYY-MM-DD");
                tempDateRange.date_until = parsedDate.format("YYYY-MM-DD");
            }
            if (key === "as_of") {
                if (parsedDate.isSameOrBefore(moment(profile.current_property_date))) {
                    tempDateRange.as_of_date = parsedDate.format("YYYY-MM-DD");
                    if (rangeType === "single_date") {
                        tempDateRange.date_until = tempDateRange.date_from;
                    }
                }
            }
            if (key === "date_from") {
                tempDateRange.date_from = parsedDate.format("YYYY-MM-DD");
            }
            if (key === "date_until") {
                tempDateRange.date_until = parsedDate.format("YYYY-MM-DD");
            }
            
            // Update tempDateRange state to trigger re-render
            setTempDateRange({...tempDateRange});
        }
    });

    const onDateChange = useCallback((event, date, key) => {
        console.log("current_property_date", profile.current_property_date)
        setIsApplyEnable(true)
        
        // Testing each condition separately
        const condition1 = isValidDateAndFormat(singleDate);
        const condition2 = isValidDateAndFormat(asOfDate);
        const condition3 = moment(asOfDate, dateDisplayFormat).isSameOrBefore(moment(profile.current_property_date));
        const condition4 = isValidDateAndFormat(inputDateFrom);
        const condition5 = isValidDateAndFormat(inputDateUntil);
        const condition6 = moment(new Date(inputDateUntil)).diff(new Date(inputDateFrom), 'days') >= 0;

        // console.log('=== Condition Testing ===');
        // console.log('Condition 1 - isValidDateAndFormat(singleDate):', condition1, 'singleDate:', singleDate);
        // console.log('Condition 2 - isValidDateAndFormat(asOfDate):', condition2, 'asOfDate:', asOfDate);
        // console.log('Condition 3 - asOfDate <= current_property_date:', condition3, 'asOfDate:', asOfDate, 'current_property_date:', profile.current_property_date);
        // console.log('Condition 4 - isValidDateAndFormat(inputDateFrom):', condition4, 'inputDateFrom:', inputDateFrom);
        // console.log('Condition 5 - isValidDateAndFormat(inputDateUntil):', condition5, 'inputDateUntil:', inputDateUntil);
        // console.log('Condition 6 - date range valid (until >= from):', condition6, 'days diff:', inputDateUntil && inputDateFrom ? moment(new Date(inputDateUntil)).diff(new Date(inputDateFrom), 'days') : 'N/A');
        // console.log('All conditions met:', condition1 && condition2 && condition3 && condition4 && condition5 && condition6);
        // console.log('========================');

        // LRV-2088 - Commented below lines
        // if (
        //     condition1 &&
        //     condition2 &&
        //     condition3 &&
        //     condition4 &&
        //     condition5 &&
        //     condition6
        // ) {
        //     setIsApplyEnable(true)
        // }
        // else{
        //     setIsApplyEnable(false)
        // }
        let calendar_on = "";
        if (datePickerConfig.type === "comparisonStayDates") {
            if ("date_from" === key) {
                tempDateRange.date_from = moment(date[0]).format("YYYY-MM-DD");
                tempDateRange.date_until = moment(tempDateRange.date_from).add(datePickerConfig.comparisonDiff, 'days').format("YYYY-MM-DD");
            }

        } else {
            if ("single" === key) {
                tempDateRange.date_from = moment(date[0]).format("YYYY-MM-DD");
                tempDateRange.date_until = tempDateRange.date_from;
                setSingleDate(moment(date[0]).format(dateDisplayFormat));
            }

            if ("as_of" === key) {
                tempDateRange.as_of_date = moment(date).format("YYYY-MM-DD");
                setAsOfDate(moment(date).format(dateDisplayFormat));
            }
            if ("date_from" === key) {
                tempDateRange.date_from = moment(date[0]).format("YYYY-MM-DD");
                setInputDateFrom(moment(date[0]).format(dateDisplayFormat))
            }
            if ("date_until" === key) {
                tempDateRange.date_until = moment(date[0]).format("YYYY-MM-DD");
                setInputDateUntil(moment(date[0]).format(dateDisplayFormat))
            }
            if ("weeks" === key) {
                // CalendarComponent already handles shift-click and returns the correct range
                // date is an array [startDate, endDate] from CalendarComponent
                if (Array.isArray(date) && date.length === 2) {
                    let start = moment(date[0]).startOf('week');
                    let end = moment(date[0]).endOf('week');
                    if (moment(date[0]).diff(moment(tempDateRange.date_from, "YYYY-MM-DD"), 'days') < 0) {
                        start = moment(date[0]).startOf("week");
                        end = moment(moment(tempDateRange.date_until, "YYYY-MM-DD")).endOf("week");
                    }

                    if (moment(date[0]).diff(moment(tempDateRange.date_until, "YYYY-MM-DD"), 'days') > 0) {
                        end = moment(date[0]).endOf('week');
                        start = moment(moment(tempDateRange.date_from, "YYYY-MM-DD")).startOf("week");

                    }
                    let hasError = rangeCapErrorCheck(isRestrictionsRoomType, active_tiles, date[0], date[1], days_limit);
                    if (hasError) {
                        setIsApplyEnable(false);
                    }
                    tempDateRange.date_from = moment(date[0]).format("YYYY-MM-DD");
                    tempDateRange.date_until = moment(date[1]).format("YYYY-MM-DD");
                } else {
                    // Fallback for single date (shouldn't happen with CalendarComponent)
                    let start = moment(date[0] || date).startOf('week');
                    let end = moment(date[0] || date).endOf('week');
                    let hasError = rangeCapErrorCheck(isRestrictionsRoomType, active_tiles, start, end, days_limit);
                    if (hasError) {
                        setIsApplyEnable(false);
                    }
                    tempDateRange.date_from = moment(start).format("YYYY-MM-DD");
                    tempDateRange.date_until = moment(end).format("YYYY-MM-DD");
                }
                calendar_on = "weeks";
            }
            if ("months" === key) {
                if (event && event.shiftKey === true) {

                    let start = moment(date[0]).startOf('month');
                    let end = moment(date[0]).endOf('month');
                    if (moment(date[0]).diff(moment(tempDateRange.date_from, "YYYY-MM-DD"), 'days') < 0) {
                        start = moment(date[0]).startOf("month");
                        end = moment(moment(tempDateRange.date_until, "YYYY-MM-DD")).endOf("month");
                    }

                    if (moment(date[0]).diff(moment(tempDateRange.date_until, "YYYY-MM-DD"), 'days') > 0) {
                        end = moment(date[0]).endOf('month');
                        start = moment(moment(tempDateRange.date_from, "YYYY-MM-DD")).startOf("month");

                    }
                    let hasError = rangeCapErrorCheck(isRestrictionsRoomType, active_tiles, start, end, days_limit);
                    if (hasError) {
                        setIsApplyEnable(false);
                    }

                    tempDateRange.date_from = moment(start).format("YYYY-MM-DD");
                    tempDateRange.date_until = moment(end).format("YYYY-MM-DD");
                } else {
                    let start = moment(date[0]).startOf('month');
                    let end = moment(date[0]).endOf('month');
                    let hasError = rangeCapErrorCheck(isRestrictionsRoomType, active_tiles, start, end, days_limit);
                    if (hasError) {
                        setIsApplyEnable(false);
                    }
                    tempDateRange.date_from = moment(start).format("YYYY-MM-DD");
                    tempDateRange.date_until = moment(end).format("YYYY-MM-DD");
                }
            }
        }
        setCalendarOn(calendar_on);
        setTempDateRange({ ...tempDateRange });
    });
    const handleRangeChange = useCallback((range_type) => {
        switch (range_type) {
            case "single_date":
                tempDateRange.date_from = moment(displayDateRange.date_from).format("YYYY-MM-DD");
                tempDateRange.date_until = moment(displayDateRange.date_from).format("YYYY-MM-DD");
                break;
            case "range":
                tempDateRange.date_from = moment(displayDateRange.date_from).format("YYYY-MM-DD");
                tempDateRange.date_until = moment(displayDateRange.date_until).format("YYYY-MM-DD");
                break;
            case "weeks":
                // tempDateRange.date_from = moment(displayDateRange.date_from).startOf('week').format("YYYY-MM-DD");
                // tempDateRange.date_until = moment(displayDateRange.date_from).endOf('week').format("YYYY-MM-DD");
                tempDateRange.date_from = moment(displayDateRange.date_from).format("YYYY-MM-DD");
                tempDateRange.date_until = moment(displayDateRange.date_until).format("YYYY-MM-DD");
                break;
            case "months":
                // tempDateRange.date_from = moment(displayDateRange.date_from).startOf('month').format("YYYY-MM-DD");
                // tempDateRange.date_until = moment(displayDateRange.date_from).endOf('month').format("YYYY-MM-DD");
                tempDateRange.date_from = moment(displayDateRange.date_from).format("YYYY-MM-DD");
                tempDateRange.date_until = moment(displayDateRange.date_until).format("YYYY-MM-DD");
                break;
            default:
                break;
        }
        setCalendarOn(range_type);
        setRangeType(range_type);
        
    });

    const rangeSegmentChange = useCallback((valueRangeSegment) => {
        if (valueRangeSegment === "current_month") {
            tempDateRange.date_from = moment().startOf('month').format("YYYY-MM-DD");
            tempDateRange.date_until = moment().endOf('month').format("YYYY-MM-DD");
        }
        if (valueRangeSegment === 29 || valueRangeSegment === 59 || valueRangeSegment === 89) {
            tempDateRange.date_from = moment().format("YYYY-MM-DD"); /// need to add as of date/ data availabilty issue
            tempDateRange.date_until = moment().add(valueRangeSegment, 'days').format("YYYY-MM-DD");
        }
        if (valueRangeSegment === "custom") {

            tempDateRange.date_from = moment().format("YYYY-MM-DD");
            tempDateRange.date_until = moment().add(valueRangeSegment, 'days').format("YYYY-MM-DD");

        }
        setInputDateFrom(moment(tempDateRange.date_from).format(dateDisplayFormat))
        setInputDateUntil(moment(tempDateRange.date_until).format(dateDisplayFormat))
        setTempDateRange(tempDateRange);
        setRangeSegment(valueRangeSegment);
        setCalendarOn('');
    });
    let dateRange = [moment(tempDateRange.date_from).toDate(), moment(tempDateRange.date_until).toDate()]
    let fromDateCalendar = (<div key='from-date' id="date-picker-calendar">
        <Calendar
            onChange={(date) => { onDateChange(null, date, "date_from"); }}
            value={dateRange}
            returnValue="range"
            calendarType="US"
            minDetail="year"
            formatMonth={(locale, date) => dateFormat(date, 'MMM')}
            showNeighboringMonth={false}
            locale={locale}
            defaultActiveStartDate={calendarMonthFrom} // assign date_from month
        />
    </div>);


    let toDateCalendar = (<div key='to-date' id="date-picker-calendar">
        <Calendar
            onChange={(date) => { onDateChange(null, date, "date_until"); }}
            value={dateRange}
            returnValue="range"
            calendarType="US"
            minDetail="year"
            formatMonth={(locale, date) => dateFormat(date, 'MMM')}
            showNeighboringMonth={false}
            locale={locale}
            defaultActiveStartDate={calendarMonthTo} // assign date_until month
        />
    </div>);

    let singleCalendar = (<div id="single-date-picker-calendar">
        <Calendar
            onChange={(date) => { onDateChange(null, date, "single"); }}
            value={moment(tempDateRange.date_from).toDate()}
            returnValue="range"
            calendarType="US"
            minDetail="year"
            formatMonth={(locale, date) => dateFormat(date, 'MMM')}
            showNeighboringMonth={false}
            locale={locale}
        />
    </div>);
   // Original weeksCalendar - commented out
    // let weeksCalendar = (<div key={'weeksCalendar'} id="week-picker-calendar">
    //     <Calendar
    //         onChange={(date, event) => { onDateChange(event, date, "weeks"); }}
    //         value={dateRange}
    //         returnValue="range"
    //         calendarType="US"
    //         maxDetail="month"
    //         minDetail="year"
    //         view="month"
    //         defaultActiveStartDate={dateRange[1]}
    //         formatMonth={(locale, date) => dateFormat(date, 'MMM')}
    //         locale={locale}
    //     />
    // </div>);

    // New weeksCalendar using CalendarComponent
    let weeksCalendar = (<div key={'weeksCalendar'} id="week-picker-calendar">
        <CalendarComponent
            onChange={(date, event) => { onDateChange(event, date, "weeks"); }}
            value={dateRange} // Pass the full date range array
            formatMonth={(locale, date) => dateFormat(date, 'MMM')}
            locale={locale}
            showNeighboringMonth={false}
            selectWeek={true} // Enable week selection
            defaultActiveStartDate={dateRange[1]} // Show month with end date
        />
    </div>);
    let monthsCalendar = (<div id="month-picker-calendar">
        <Calendar
            onChange={(date, event) => { onDateChange(event, date, "months"); }}
            value={dateRange}
            returnValue="range"
            calendarType="US"
            maxDetail="year"
            view="year"
            prev2Label={null}
            next2Label={null}
            formatMonth={(locale, date) => dateFormat(date, 'MMM')}
            locale={locale}
        />
    </div>);
    let asOfCalendar = (<div id="date-picker-calendar-asof">
        <Calendar
            onChange={(date) => { onDateChange(null, date, "as_of"); }}
            value={moment(tempDateRange.as_of_date).toDate()}
            returnValue="start"
            calendarType="US"
            minDetail="year"
            maxDate={moment(profile.current_property_date).toDate()}
            prev2Label={null}
            next2Label={null}
            formatMonth={(locale, date) => dateFormat(date, 'MMM')}
            className={isApplyEnable ? 'calendar-asof' : 'calendar-asof hide-date-selection'}
            locale={locale}
        />
    </div>);


    let rangeSegmentLabels = navigation?.range?.range_segments?.map((segment, index) => {
        let label = "";
        switch (segment) {
            case "current_month":
                label = <div className='current-month'><span className='this-month'>This</span><span className='days-label'> Month</span></div>;
                break;
            case 29:
                label = <><span className='next-label'>next</span><span className='days-num'>30</span><span className='days-label'> days</span></>;
                break;
            case 59:
                label = <><span className='next-label'>next</span><span className='days-num'>60</span><span className='days-label'> days</span></>;
                break;
            case 89:
                label = <><span className='next-label'>next</span><span className='days-num'>90</span><span className='days-label'> days</span></>;
                break;
            case "sdly":
                label = "Same Period, SDLY";
                break;
            case "custom":
                label = "Custom";
                break;
            default:
                label = "";
        }
        return (<Button key={index} className={(rangeSegment === segment) ? "days-num-btn active" : "days-num-btn"} onClick={() => { rangeSegmentChange(segment) }}>{label}</Button>)
    })

    let ranges = Object.entries(navigation);
    const rangeCount = ranges.length;
    const activeIndex = Math.max(0, ranges.findIndex(([key]) => key === rangeType));
    const rangeIndicatorStyle = { width: `calc((100% - 4px) / ${rangeCount})`, transform: `translateX(${activeIndex * 100}%)`, };
    let rangeTypes = [];
    for (let index = 0; index < ranges.length; index++) {
        const item = ranges[index];
        let disabledClass = (in_array(active_tiles[0], ["DailyRatesendStatus", "restrictions_push_status", "rm_room_type_ratesend_status"]) 
            && app_state.workspace_controls.logsRatePushMode === "date" && item[0] !== "single_date") ? "disabled-range-type" : "";

        let range_type = (disabledClass && disabledClass !== "") ? "single_date" : rangeType;
        if (app_state.workspace_controls.scopeType === 'Dba') {
            disabledClass = "disabled-range-type";
            range_type = "single_date";
        } else {
            disabledClass = "";
            range_type = rangeType;
        }
        let borderRight="";
        if(index !== rangeCount - 1){
            borderRight=(<span className="border-right"></span>);
            if(range_type === item[0]){
                borderRight="";
            }
            if(index < rangeCount - 1 && range_type === ranges[index+1][0]){
                borderRight="";
            }
        }
        rangeTypes.push(
            <label
                key={index}
                className={(range_type !== item[0]) ? disabledClass + " btn btn-default " : "btn btn-default active"}
                onClick={() => {
                    if (!disabledClass) {
                        handleRangeChange(item[0])
                    }
                }}
            >
                {item[1].label}
                {borderRight}
                 
            </label>
        );
    }
    switch (rangeType) {
        case "single_date":
            selector = (<div className="range-selector row" style={{ "paddingTop": "0px" }}>
                <div className="form-group col-md-12 single-date-picker" style={{ "marginBottom": 0 }}>
                    <label className="label">Date:</label>
                    <TextField
                        fullWidth
                        label=""
                        inputProps={{ tabIndex: "1" }}
                        placeholder='MMM dd, yyyy'
                        size="small"
                        id="singleDatePicker"
                        className='date-picker'
                        name="singleDate"
                        error={!isValidDateAndFormat(singleDate)}
                        onFocus={() => { handleDateInputFocus("single") }}
                        onChange={(event) => handleDateInputChange(event.target.value, "single")}
                        value={singleDate}
                    />
                </div>
                {(calendarOn === "single") && singleCalendar}
            </div>);
            break;
        case "range":

            selector = (<div className='range-section'>
                <div className="range-segments " >
                    <ButtonGroup className='days-slect-group' size='small' fullWidth variant="outlined" aria-label="outlined primary button group">
                        {rangeSegmentLabels}
                    </ButtonGroup>
                </div>
                <div className="range-selector" style={{ "paddingTop": "8px" }}>
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <label>From:</label>
                            <TextField
                                label=""
                                inputProps={{ tabIndex: "1" }}
                                placeholder='MMM DD, YYYY'
                                size="small"
                                id="dateFrom"
                                name="dateFrom"
                                className="date-picker range-from"
                                error={!isValidDateAndFormat(inputDateFrom) || (isValidDateAndFormat(inputDateFrom) && isValidDateAndFormat(inputDateUntil) && moment(inputDateFrom, dateDisplayFormat).isAfter(moment(inputDateUntil, dateDisplayFormat))) || rangeCapErrorCheck(isRestrictionsRoomType, active_tiles, inputDateFrom, inputDateUntil, days_limit)}
                                onFocus={(event) => { handleDateInputFocus("date_from", event.target.value) }}
                                onChange={(event) => handleDateInputChange(event.target.value, "date_from")}
                                value={inputDateFrom}
                            />
                        </Grid>
                        <Grid item xs={6} sx={{ pl: '4px' }}>
                            <label>To:</label>
                            <TextField
                                label=""
                                inputProps={{ tabIndex: "1" }}
                                placeholder='MMM DD, YYYY'
                                size="small"
                                id="dateUntil"
                                name="dateUntil"
                                className="date-picker range-until"
                                error={!isValidDateAndFormat(inputDateUntil) || (isValidDateAndFormat(inputDateFrom) && isValidDateAndFormat(inputDateUntil) && moment(inputDateUntil, dateDisplayFormat).isBefore(moment(inputDateFrom, dateDisplayFormat))) || rangeCapErrorCheck(isRestrictionsRoomType, active_tiles, inputDateFrom, inputDateUntil, days_limit)}
                                onFocus={(event) => { handleDateInputFocus("date_until", event.target.value) }}
                                onChange={(event) => handleDateInputChange(event.target.value, "date_until")}
                                value={inputDateUntil}
                                disabled={datePickerConfig.type === "comparisonStayDates"}
                            />
                        </Grid>
                        <div>

                            {(calendarOn === "date_from" && navigation?.range?.inputs?.indexOf("date_from") > -1) && <div className='calendar-box'>{fromDateCalendar}</div>}
                            {(calendarOn === "date_until" && navigation?.range?.inputs?.indexOf("date_until") > -1) && <div className='calendar-box'>{toDateCalendar}</div>}
                        </div>
                    </Grid>



                </div>
            </div>);
            break;

        case "weeks":
            selector = (<div className="range-selector row" style={{ "paddingTop": "0px" }}>
                {weeksCalendar}
            </div>);
            break;

        case "months":
            selector = (<div className="months range-selector row" >
                {monthsCalendar}
            </div>);
            break;
        default:
            selector = (<span></span>);
    }

    let popoverStyles = { "top": "0px", "display": "block", "visibility": "visible" };
    let isMobile = isMobileDevice();
    if (isMobile) {
        popoverStyles.top = "-40px";
        popoverStyles.transform = "scale(.65)";
    }
    let noAsOfTiles = ['DailyRatesendStatus', 'rm_room_type_ratesend_status', "restrictions_push_status",'plr_logs'];
    let asOfSelectorHide =(app_state.workspace_controls.scopeType === "Dba" && active_tiles[0] === "pace") ||
    (in_array(active_tiles[0], ["DailyRatesendStatus", "rm_room_type_ratesend_status", "restrictions_push_status", 'plr_logs']) && app_state.workspace_controls.logsRatePushMode === "date" ) ||
    (in_array(active_tiles[0], ["bi_sensitivity_analysis", "group_iq_reports"]))
    let popup = (<div className="popover bottom-left" style={popoverStyles}>
        <div className="arrow"></div>
        <div className="popover-content" style={{ "padding": "10px" }}>
            <div>
                {app_state.workspace_controls.scopeType === "Dba" ||
                    (noAsOfTiles.includes(active_tiles[0]) && app_state.workspace_controls.logsRatePushMode === 'date') ? null :
                    <div 
                        className="range-types-wrapper"
                        style={{ '--active-index': activeIndex, '--range-count': rangeCount }}
                    >
                        <div className="btn-group btn-group-justified range-types">
                            {rangeTypes}
                        </div>
                        <div className={`active-indicator activeIndex-${activeIndex}`} />
                    </div>
                }
                {selector}

                {(isRestrictionsRoomType === 'product' && active_tiles.includes('restrictions') && rangeType !== 'single_date') &&
                    <div className='info-text-days-cap' >A maximum of {days_limit + 1} days can be selected for product level restrictions.</div>
                }

                {(navigation[rangeType].as_of_date === true) && (<div className="asof-selector clearfix" style={{ "clear": "both" }}>


                    <Grid container spacing={1} sx={{ mt: 1.5 }}>
                      
                        <div className='input-field-container'>

                            {
                                (asOfSelectorHide ||
                                    (in_array(active_tiles[0], ["DailyRatesendStatus", "rm_room_type_ratesend_status", "restrictions_push_status",]) && app_state.workspace_controls.logsRatePushMode === "date") ||
                                    (in_array(active_tiles[0], ["bi_sensitivity_analysis", "group_iq_reports"])) ?
                                    <></> : <div>
                                                              
                                        <label className="label">As Of Date:</label>

                                        <TextField
                                            label=""
                                            inputProps={{ tabIndex: "1" }}
                                            placeholder='MMM DD, YYYY'
                                            size="small"
                                            id="asOfDate"
                                            name="asOfDate"
                                            className='date-picker'
                                            error={moment(asOfDate, dateDisplayFormat).isAfter(moment(profile.current_property_date)) || !isValidDateAndFormat(asOfDate)}
                                            onFocus={() => { handleDateInputFocus("as_of") }}
                                            onChange={(event) => handleDateInputChange(event.target.value, "as_of")}
                                            value={asOfDate}
                                            disabled={isRestrictionsRoomType === 'product' && active_tiles.includes('restrictions')}
                                        />
                                    </div>
                                )}
                        </div>
                        <div className='button-container apply-button-container' style={{ marginTop: asOfSelectorHide ?   0 : '17px'}}>
                            <div>{
                                isApplyEnable ?
                                    (<button type="button" className="btn btn-info btn-block " tabIndex={1} onMouseDown={()=>{
                                        console.log("apply");
                                    }} onMouseUp={()=>{
                                        console.log("apply");
                                    }} onClick={() =>{
                                        applyChange("as_of_date", 'picker')
                                    }} >Apply</button>) :
                                    (<button type="button" className="btn btn-info btn-block btn-disabled">Apply</button>)
                            }</div>
                        </div>

                        {(calendarOn === "as_of" === true) &&
                            <Grid item xs={12}>
                                <div className='calendar-box'>
                                    {asOfCalendar}
                                </div>
                            </Grid>
                        }


                    </Grid>
                    <div className="row">


                    </div>

                </div>
                )}
            </div>
        </div>
    </div>
    )
    let shiftBackwardBtn = () => (<button type="button" className="btn-stay-range shift-prev" onClick={shiftBackward} disabled={ui_state.showspinner}>
        {/* <ArrowBackIosIcon fontSize='small' /> */}
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#606060" viewBox="0 0 256 256"><path d="M168,48V208a8,8,0,0,1-13.66,5.66l-80-80a8,8,0,0,1,0-11.32l80-80A8,8,0,0,1,168,48Z"></path></svg>
    </button>);
    let shiftFowardBtn = () => (<button type="button" className="btn-stay-range shift-next" onClick={shiftFoward} disabled={ui_state.showspinner}>
        {/* <ArrowForwardIosIcon fontSize='small' /> */}
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#606060" viewBox="0 0 256 256"><path d="M181.66,133.66l-80,80A8,8,0,0,1,88,208V48a8,8,0,0,1,13.66-5.66l80,80A8,8,0,0,1,181.66,133.66Z"></path></svg>
    </button>);
    let topLabel = (<span></span>);
    //let noAsOfTiles = ['DailyRatesendStatus', 'rm_room_type_ratesend_status', "restrictions_push_status"];
    if (noAsOfTiles.includes(active_tiles[0]) && app_state.workspace_controls.logsRatePushMode === 'date') {
        // debugger;
        topLabel = (<label className="label"> </label>);
    } else if (app_state.workspace_controls.scopeType === "Dba" && active_tiles[0] === 'pace' || active_tiles[0] === 'bi_sensitivity_analysis') {
        topLabel = (<label className="label"> </label>);
    } else if (datePickerConfig.type === "primaryStayDates") {
        if (active_tiles[0] === "group_iq_reports") {
            topLabel = (<label className="label">Select Date Range</label>);
        }
        else {
            topLabel = (<label className="label">Stay Dates -
                <span className="date-text"> As of </span>
                <span className="">{dateFormat(displayDateRange.as_of_date, "ddd, MMM DD, YYYY")}</span>
            </label>);
        }
    } else if (datePickerConfig.type === "comparisonStayDates") {
        topLabel = (<label className="label">Compare To</label>);
    }
    return (
        <>


            <div className="smart-date-picker" style={{ "display": " inline-block", "verticalAlign": "top" }}>
                <div className="chart-stay-date clearfix current-date-range" id="stay-date">
                    {topLabel}
                    <div className="stay-date-picker clearfix" id="stay-date-picker-id">
                        {(datePickerConfig.shiftBtns === true) && shiftBackwardBtn()}
                        <button type="button" className="btn-stay-picker clearfix"
                            onClick={(event) => { openDatePickerHandler(event) }}
                        >
                            {/* {(datePickerConfig.dateRangeKey === "comparison_stay_range" && initialLoad) && (<span>Select Dates</span>)} */}
                            {(datePickerConfig.dateRangeKey !== "comparison_stay_range") && (<span><span className="rangeFromDate ">{dateFormat(displayDateRange.date_from, "ddd, MMM DD")}</span> -
                                <span className="rangeToDate" >{dateFormat(displayDateRange.date_until, "ddd, MMM DD, YYYY")}</span> </span>)}
                        </button>
                        <Popover
                            PaperProps={{ elevation: 0, sx: { backgroundColor: 'transparent', boxShadow: 'none', mt: -1,transition: 'none', overflow: 'hidden' } }}
                            id={id}
                            open={openDatePicker}
                            transitionDuration={0}

                            anchorEl={anchorEl}
                            onClose={() => closeDatePickerHandler()}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            sx={{ backgroundColor: 'transparent', mt: '-10px', ml: '-26px' }}
                            className="elevation0 date-picker-popover"
                        >
                            <div className='date-picker-wrapper'>
                                {popup}
                            </div>

                        </Popover>
                        {(datePickerConfig.shiftBtns === true) && shiftFowardBtn()}

                    </div>
                </div>
            </div>
        </>);
}